import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=60357ef7&scoped=true"
import script from "./filters.vue?vue&type=script&lang=js"
export * from "./filters.vue?vue&type=script&lang=js"
import style0 from "./filters.vue?vue&type=style&index=0&id=60357ef7&prod&scoped=true&lang=scss"
import style1 from "./filters.vue?vue&type=style&index=1&id=60357ef7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60357ef7",
  null
  
)

export default component.exports